module.exports = __webpack_public_path__ + "static/media/vitacura.f5d2dba0.jpg";